import { FC, memo, PropsWithChildren, useMemo, useState } from 'react';

import { Nullable } from '~/core/shared/types';
import { ApplicationDisplayData } from '~/core/shared/types/models';
import { AdminApplicationContext } from './AdminApplicationContext';

const AdminApplicationProviderComponent: FC<PropsWithChildren> = ({
  children,
}) => {
  const [displayData, setDisplayData] =
    useState<Nullable<ApplicationDisplayData>>(null);

  const value = useMemo(() => ({ displayData, setDisplayData }), [displayData]);

  return (
    <AdminApplicationContext.Provider value={value}>
      {children}
    </AdminApplicationContext.Provider>
  );
};

export const AdminApplicationProvider = memo(AdminApplicationProviderComponent);
